import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getHistoricalByGroup (order = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    const data = await new Promise((resolve, reject) => {
      resolve(mock.getHistorical)
    })
    data.listaEventos = data.data.filter(x => x.tipoItem === 'Grupo' && x.idItem === Number.parseInt(params.idGrupo))
    return data
  } else {
    const req = {
      url: '/api/historico/getgrupohistorico',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: order,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getHistoricalByGroup }
